import { render, staticRenderFns } from "./TestimonialsCard.vue?vue&type=template&id=8ff4e418&scoped=true"
import script from "./TestimonialsCard.js?vue&type=script&lang=js&external"
export * from "./TestimonialsCard.js?vue&type=script&lang=js&external"
import style0 from "./TestimonialsCard.scss?vue&type=style&index=0&id=8ff4e418&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff4e418",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
